import { jsx as c } from "react/jsx-runtime";
import * as l from "react";
import { c as $, P as m, b as g, d as D } from "./index-BwqhVa-H.js";
import { c as h, R as V, I as G } from "./index-v1XNqkXV.js";
import { P as k } from "./index-Co1YE7s6.js";
import { a as L, u as j } from "./index-DfspMmaX.js";
import { c as T } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
var p = "Tabs", [K] = $(p, [
  h
]), N = h(), [B, y] = K(p), C = l.forwardRef(
  (e, a) => {
    const {
      __scopeTabs: t,
      value: o,
      onValueChange: n,
      defaultValue: d,
      orientation: r = "horizontal",
      dir: u,
      activationMode: v = "automatic",
      ...b
    } = e, i = L(u), [s, f] = D({
      prop: o,
      onChange: n,
      defaultProp: d ?? "",
      caller: p
    });
    return /* @__PURE__ */ c(
      B,
      {
        scope: t,
        baseId: j(),
        value: s,
        onValueChange: f,
        orientation: r,
        dir: i,
        activationMode: v,
        children: /* @__PURE__ */ c(
          m.div,
          {
            dir: i,
            "data-orientation": r,
            ...b,
            ref: a
          }
        )
      }
    );
  }
);
C.displayName = p;
var I = "TabsList", R = l.forwardRef(
  (e, a) => {
    const { __scopeTabs: t, loop: o = !0, ...n } = e, d = y(I, t), r = N(t);
    return /* @__PURE__ */ c(
      V,
      {
        asChild: !0,
        ...r,
        orientation: d.orientation,
        dir: d.dir,
        loop: o,
        children: /* @__PURE__ */ c(
          m.div,
          {
            role: "tablist",
            "aria-orientation": d.orientation,
            ...n,
            ref: a
          }
        )
      }
    );
  }
);
R.displayName = I;
var x = "TabsTrigger", w = l.forwardRef(
  (e, a) => {
    const { __scopeTabs: t, value: o, disabled: n = !1, ...d } = e, r = y(x, t), u = N(t), v = P(r.baseId, o), b = M(r.baseId, o), i = o === r.value;
    return /* @__PURE__ */ c(
      G,
      {
        asChild: !0,
        ...u,
        focusable: !n,
        active: i,
        children: /* @__PURE__ */ c(
          m.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": i,
            "aria-controls": b,
            "data-state": i ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: v,
            ...d,
            ref: a,
            onMouseDown: g(e.onMouseDown, (s) => {
              !n && s.button === 0 && s.ctrlKey === !1 ? r.onValueChange(o) : s.preventDefault();
            }),
            onKeyDown: g(e.onKeyDown, (s) => {
              [" ", "Enter"].includes(s.key) && r.onValueChange(o);
            }),
            onFocus: g(e.onFocus, () => {
              const s = r.activationMode !== "manual";
              !i && !n && s && r.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
w.displayName = x;
var _ = "TabsContent", A = l.forwardRef(
  (e, a) => {
    const { __scopeTabs: t, value: o, forceMount: n, children: d, ...r } = e, u = y(_, t), v = P(u.baseId, o), b = M(u.baseId, o), i = o === u.value, s = l.useRef(i);
    return l.useEffect(() => {
      const f = requestAnimationFrame(() => s.current = !1);
      return () => cancelAnimationFrame(f);
    }, []), /* @__PURE__ */ c(k, { present: n || i, children: ({ present: f }) => /* @__PURE__ */ c(
      m.div,
      {
        "data-state": i ? "active" : "inactive",
        "data-orientation": u.orientation,
        role: "tabpanel",
        "aria-labelledby": v,
        hidden: !f,
        id: b,
        tabIndex: 0,
        ...r,
        ref: a,
        style: {
          ...e.style,
          animationDuration: s.current ? "0s" : void 0
        },
        children: f && d
      }
    ) });
  }
);
A.displayName = _;
function P(e, a) {
  return `${e}-trigger-${a}`;
}
function M(e, a) {
  return `${e}-content-${a}`;
}
var q = C, S = R, E = w, F = A;
const ae = q, z = l.forwardRef(({ className: e, ...a }, t) => /* @__PURE__ */ c(
  S,
  {
    ref: t,
    className: T(
      "inline-flex h-10 items-center justify-center rounded-[var(--ds-radius-md)] bg-[var(--ds-color-bg-surface-subtle)] p-1 text-[var(--ds-color-fg-muted)]",
      e
    ),
    ...a
  }
));
z.displayName = S.displayName;
const H = l.forwardRef(({ className: e, ...a }, t) => /* @__PURE__ */ c(
  E,
  {
    ref: t,
    className: T(
      "inline-flex items-center justify-center whitespace-nowrap rounded-[var(--ds-radius-sm)] px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-[var(--ds-color-bg-surface-default)] data-[state=active]:text-[var(--ds-color-fg-default)] data-[state=active]:shadow-elevation-1",
      e
    ),
    ...a
  }
));
H.displayName = E.displayName;
const O = l.forwardRef(({ className: e, ...a }, t) => /* @__PURE__ */ c(
  F,
  {
    ref: t,
    className: T(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ds-color-border-primary)] focus-visible:ring-offset-2",
      e
    ),
    ...a
  }
));
O.displayName = F.displayName;
export {
  ae as T,
  z as a,
  H as b,
  O as c
};
